/*global navigator, localStorage */

const getLocale = (manifest, sessions, userId) => {
    const languagePreferences = [];
    if (sessions) {
        for (let i = 0, l = sessions.length; i < l; i += 1) {
            const session = sessions[i];
            const language = session.language;
            if (session.userId === userId) {
                languagePreferences.unshift(language);
            } else {
                languagePreferences.push(language);
            }
        }
    }

    try {
        const appLanguage = localStorage.getItem('preferences.language');
        if (appLanguage) {
            languagePreferences.push(appLanguage);
        }
    } catch (error) {}

    const browserLanguage = navigator.language || navigator.userLanguage || '';
    if (browserLanguage) {
        languagePreferences.push(browserLanguage.toLowerCase());
    }

    const getFile = (language) => {
        const entry = manifest[`/locale/${language}.js`];
        if (entry) {
            return entry.file;
        }
        return null;
    };

    return getFile('en-gb');
};

// ---

export { getLocale };
